import { Components } from 'formiojs';

// Test function to check if barcode reader is registered
export function testBarcodeReaderRegistration() {
  console.log('Testing barcode reader registration...');
  console.log('Available components:', Object.keys((Components as any).components));
  console.log('Barcode reader component:', (Components as any).components.barcodereader);
  
  if ((Components as any).components.barcodereader) {
    console.log('✅ Barcode reader component is registered');
    console.log('Builder info:', (Components as any).components.barcodereader.builderInfo);
  } else {
    console.log('❌ Barcode reader component is NOT registered');
  }
}

// Call this function after a delay to ensure components are loaded
setTimeout(() => {
  testBarcodeReaderRegistration();
}, 2000);